"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEAL_STATUS_NL = exports.DealStatus = void 0;
var DealStatus;
(function (DealStatus) {
    DealStatus["Accepted"] = "accepted";
    DealStatus["Expired"] = "expired";
    DealStatus["Lost"] = "lost";
    DealStatus["OnHold"] = "onHold";
    DealStatus["Open"] = "open";
})(DealStatus = exports.DealStatus || (exports.DealStatus = {}));
exports.DEAL_STATUS_NL = {
    accepted: 'Akkoord',
    expired: 'Verlopen',
    lost: 'Verloren',
    onHold: 'In Afwachting/Uitgesteld',
    open: 'Open',
};
